import { Button } from '@crm/ui';
import { Maximize2, Minimize2 } from 'lucide-react';
import { useEffect, useState } from 'react';

/**
 * O mesmo que apertar F11: tira a moldura do navegador e deixa a aplicacao
 * inteira - barra do topo e menu inclusive - ocupando a tela. Sai pelo botao
 * ou pelo Esc.
 */
export function FullscreenButton({ compact = false }: { compact?: boolean }) {
  const [isFullscreen, setFullscreen] = useState(() => Boolean(document.fullscreenElement));

  useEffect(() => {
    const onChange = () => setFullscreen(Boolean(document.fullscreenElement));

    document.addEventListener('fullscreenchange', onChange);

    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  return (
    <Button
      // Na barra do topo ele e so o icone, do tamanho dos vizinhos.
      variant={compact ? 'ghost' : 'outline'}
      size={compact ? 'icon' : undefined}
      // Icone de apoio: 44px de alvo bastam, e o icone grande competia com o
      // titulo da tela ao lado.
      className={compact ? 'h-11 w-11 [&_svg]:size-5' : undefined}
      aria-label={isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
      title={isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
      onClick={() => {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch(() => undefined);
          return;
        }

        document.documentElement.requestFullscreen?.().catch(() => undefined);
      }}
    >
      {isFullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
      {compact ? null : isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
    </Button>
  );
}
